import { render, staticRenderFns } from "./BundlePreview.vue?vue&type=template&id=56fd01c6&"
import script from "./BundlePreview.vue?vue&type=script&lang=ts&"
export * from "./BundlePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports